import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Box, Collapse } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { EntitySoxPicker } from './EntitySoxPicker';
import { EntitySoc2Picker } from './EntitySoc2Picker';
import { EntityComponentTierPicker } from './EntityComponentTierPicker';
import { EntityStackPicker } from './EntityStackPicker';

/** @public */
export type CatalogReactMoreFiltersButtonClassKey =
  | 'button'
  | 'expandedContent';

const useStyles = makeStyles(
  theme => ({
    button: {
      marginTop: '16px',
      width: '100%',
      border: `1px solid ${theme.palette.divider}`,
      borderBottom: 'none',
      borderRadius: '4px 4px 0 0',
      backgroundColor: theme.palette.background.paper,
    },
    expandedContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      padding: '8px',
      border: `1px solid ${theme.palette.divider}`,
      borderTop: 'none',
      borderRadius: '0 0 4px 4px',
      backgroundColor: theme.palette.background.paper,
    },
  }),
  { name: 'CatalogReactMoreFiltersButton' },
);

/** @public */
export const MoreFiltersButton = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={handleToggle}
        className={classes.button}
        endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
      >
        More Filters
      </Button>
      <Collapse in={expanded}>
        <Box className={classes.expandedContent}>
          <EntityStackPicker />
          <EntitySoxPicker />
          <EntitySoc2Picker />
          <EntityComponentTierPicker />
        </Box>
      </Collapse>
    </>
  );
};
